import React from 'react';

const ThresholdContext = React.createContext();

export default ThresholdContext;
